<template>
  <div>
    <RequirementAlerts
      :current-deadline="currentDeadline"
      :requirements="allRequirements"
      :only-requires-bank-account="onlyRequiresBankAccount"
    />
    <button
      v-if="!onlyRequiresBankAccount"
      type="button"
      class="mb-2 btn btn--sm"
      @click="provideRequiredInfo"
      v-text="buttonText"
    />
  </div>
</template>

<script type="text/babel">
import {mapActions, mapState} from 'vuex'
import format from 'date-fns/format'
import fromUnixTime from 'date-fns/fromUnixTime'
import RequirementAlerts from './RequirementAlerts'

export default {
  name: 'Requirements',
  components: {
    RequirementAlerts,
  },
  computed: {
    ...mapState({
      stripeAccount: state => state.payments.stripeAccount,
    }),
    requiresBankAccount() {
      if (!_.isEmpty(this.stripeAccount)) {
        const combinedRequirements = new Set([
          ...this.stripeAccount.requirements.currently_due,
          ...this.stripeAccount.requirements.eventually_due,
          ...this.stripeAccount.requirements.past_due,
        ])

        return combinedRequirements.has('external_account')
      }

      return false
    },
    allRequirements() {
      return !_.isEmpty(this.stripeAccount)
        ? {
          requirements: this.stripeAccount.requirements,
          futureRequirements: this.stripeAccount.future_requirements,
        }
        : {}
    },
    currentDeadline() {
      if (!_.isEmpty(this.stripeAccount)) {
        const deadline = this.stripeAccount.requirements.current_deadline || this.stripeAccount.future_requirements.current_deadline

        return deadline ? format(fromUnixTime(deadline), 'MMMM d, yyyy') : false
      }

      return false
    },
    buttonText() {
      return !_.isEmpty(this.stripeAccount) ? 'Provide Required Information' : 'Begin Onboarding'
    },
    onlyRequiresBankAccount() {
      if (!_.isEmpty(this.stripeAccount)) {
        const combinedRequirements = new Set([
          ...this.stripeAccount.requirements.currently_due,
          ...this.stripeAccount.requirements.eventually_due,
          ...this.stripeAccount.requirements.past_due,
        ])

        return combinedRequirements.size === 1 && combinedRequirements.has('external_account')
      }

      return false
    },
  },
  methods: {
    ...mapActions([
      'getAccountLink',
    ]),
    async provideRequiredInfo() {
      window.location = await this.getAccountLink()
    },
  },
}
</script>
